<template>
    <div v-if="visible" class="send-notice-components">
        <el-dialog
            class="send-notice-dialog"
            :visible.sync="visible"
            :title="$t('Setting.notice')"
            left>
            <el-form
                label-width="60px"
                :rules="rules"
                ref="form"
                :model="form"
                label-position="left">
                <el-form-item prop="title" :label="$t('Setting.Message.title')">
                    <el-input type="text" v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item prop="content" :label="$t('Setting.content')">
                    <tinymce v-model="form.content" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submit">{{ $t('Setting.send') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog} from 'element-ui';
import Tinymce from '@/components/base/Tinymce';

export default {
    name: 'send-notice',
    components: {
        ElDialog: Dialog,
        tinymce: Tinymce
    },
    data() {
        return {
            visible: false,
            form: {
                title: '',
                content: '',
            },
            rules: {
                title: { required: true, message: this.$t('Setting.Notice.fill_title'), },
                content: { required: true, message: this.$t('Setting.Notice.fill_content'), },
            },
        };
    },
    watch: {
        visible(val) {
            if (!val) this.resetForm();
        },
    },
    methods: {
        resetForm() {
            this.$refs.form.resetFields();
            this.$refs.form.clearValidate();
        },
        open() {
            this.visible = true;
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.postData();
            });
        },
        postData() {
            API.post('notice', this.form).then(() => {
                $ele.$message.success(this.$t('Message.send_success'));
                this.$emit('fetchNotice');
                this.visible = false;
            });
        },
    },
};

</script>

<style lang="scss">
.send-notice-components.el-dialog {
    width: 30%;
    height: 250px;
}
</style>
